import script from "./ShipListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShipListView.vue?vue&type=script&lang=ts&setup=true"

import "./ShipListView.vue?vue&type=style&index=0&id=550ea509&lang=less&scoped=true"
import "./ShipListView.vue?vue&type=style&index=1&id=550ea509&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-550ea509"]])

export default __exports__